export default __webpack_public_path__ + "static/datadog-ba3205a59d8d469ddc875b9cfb895005.png";